'use strict';

exports['default'] = 'text';


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-text-renderer/dist/commonjs/mobiledoc-text-renderer/utils/render-type.js
// module id = 218
// module chunks = 0